import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=e03745dc&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e03745dc')) {
      api.createRecord('e03745dc', component.options)
    } else {
      api.reload('e03745dc', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=e03745dc&", function () {
      api.rerender('e03745dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OhOW12vVVT0e/JS/comp/childrenage.vue"
export default component.exports